export const config = {
  publicUrl: process.env.PUBLIC_URL || '',
  email: process.env.REACT_APP_EMAIL,
  phone: process.env.REACT_APP_PHONE,
  accountingApiUrl: process.env.REACT_APP_ACCOUNTING_API_URL,
  customerApiUrl: process.env.REACT_APP_CUSTOMER_API_URL,
  ordersApiUrl: process.env.REACT_APP_ORDERS_API_URL,
  usersApiUrl: process.env.REACT_APP_USERS_API_URL,
  calendlyUrl: process.env.REACT_APP_CALENDLY_URL,
  sendbirdAppId: process.env.REACT_APP_SENDBIRD_APP_ID,
  devtools: process.env.REACT_APP_DEVTOOLS,
};
